"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.envVariableNames = void 0;
/**
 * Names of env. variables that servinb-box uses. While these do not appear in the request/response objects of a
 * serving-box they are part of the externally-visible configuration surface of a serving-box (and hence are part of
 * the "serving-box-api" module)
 */
exports.envVariableNames = {
    binaryId: 'binaryId',
    quotaName: 'quotaName',
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZW52LXZhcmlhYmxlcy1uYW1lcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9lbnYtdmFyaWFibGVzLW5hbWVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBOzs7O0dBSUc7QUFDVSxRQUFBLGdCQUFnQixHQUFHO0lBQzlCLFFBQVEsRUFBRSxVQUFVO0lBQ3BCLFNBQVMsRUFBRSxXQUFXO0NBQ3ZCLENBQUEifQ==